/* eslint-disable flowtype/no-types-missing-file-annotation */
import {SVGIcon} from '@homeaway/react-svg';
import {TOUR_360__24} from '@homeaway/svg-defs';
import {debounce} from 'lodash';
import React from 'react';

import {trigger, GENERIC_EVENT} from '../../utils/edapWrapper';

import './VirtualTourBadge.less';

import {BadgeShape} from '../Hit/Hit';

const handleMouseEnter = debounce(() => {
    trigger(GENERIC_EVENT, {
        eventaction: 'hover virtual tour badge'
    });
}, 100);

export type Props = {
    badge: BadgeShape;
    detailPageUrl?: string;
    onBadgeClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
};

export function VirtualTourBadge(props: Props) {
    const {badge, detailPageUrl, onBadgeClick} = props;

    return (
        <a
            className="VirtualTourBadge"
            onMouseEnter={handleMouseEnter}
            role="presentation"
            target="_blank"
            href={detailPageUrl}
            onClick={onBadgeClick}
            tabIndex={0}
        >
            <SVGIcon
                markup={TOUR_360__24}
                aria-hidden
                className="VirtualTourBadge__icon"
            />
            <div className="VirtualTourBadge__text-container">
                <span className="VirtualTourBadge__text">{badge.name}</span>
            </div>
        </a>
    );
}
